import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/core/services/user.service';
import { DictionaryEntity } from '@app/pcs/models';
import {
  MultiSelectGridFilterDirective
} from '@app/pcs/shared/containers/search-results-grid/filters/multi-select-grid-filter.directive';
import { Store } from '@ngrx/store';
import { hasNoValue, hasValue, isArray, isBoolean, isFalse, isTrue } from '@util';
import * as R from 'ramda';

interface ImFilterValue {
  addressedToMyIm: boolean;
  options: DictionaryEntity[];
}

type FilterValue = ImFilterValue | DictionaryEntity | boolean;

const instanceOfImFilterValue = (filterValue) => R.is(Object, filterValue) && R.hasIn('addressedToMyIm', filterValue)
  && R.hasIn('options', filterValue);

@Component({
  templateUrl: './observation-types-filter.component.html'
})
export class ObservationTypesFilterComponent extends MultiSelectGridFilterDirective<FilterValue> implements OnInit {
  addressedToMyIm = false;

  constructor(protected store: Store<any>, private userService: UserService) {
    super(store);
  }

  ngOnInit() {
    super.ngOnInit();
    if (isBoolean(this.value)) {
      this.showOnlyRowsWithNoOptions = this.value;
    } else if (isArray(this.value)) {
      this.selectedOptions = this.value as DictionaryEntity[];
    } else if (instanceOfImFilterValue(this.value)){
      const {addressedToMyIm, options} = this.value as ImFilterValue;
      this.addressedToMyIm = addressedToMyIm;
      this.selectedOptions = options as DictionaryEntity[];
    }
  }

  filter(input: any): boolean {
    const {option, value, dataItemValue} = input;
    const {observationTypes, involvedImIds, userAgencyId} = dataItemValue;
    if (!instanceOfImFilterValue(value)) {
      return super.filter({option, value, rawValue: observationTypes});
    }

    const {addressedToMyIm, options} = value;
    const addressedToMyImCondition = isFalse(addressedToMyIm) || R.includes(userAgencyId as number, involvedImIds);
    const selectedOptionsCondition = hasNoValue(options) || super.filter({option, value: options, rawValue: observationTypes});
    return addressedToMyImCondition && selectedOptionsCondition;
  }

  onAddressedToMyIMOptionChanged(value) {
    this.addressedToMyIm = value;
    this.valueChanged.emit(this.imFilterValue());
  }

  onOptionSelected(value: DictionaryEntity[]) {
    this.selectedOptions = value;
    if (this.isImUser()) {
      this.valueChanged.emit(this.imFilterValue());
    } else {
      this.valueChanged.emit(this.selectedOptions);
    }
  }

  isImUser() {
    return this.userService.isImUser();
  }

  private imFilterValue() {
    return isTrue(this.addressedToMyIm) || hasValue(this.selectedOptions)
      ? {addressedToMyIm: this.addressedToMyIm, options: this.selectedOptions} as ImFilterValue
      : {} as ImFilterValue;
  }
}
